import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function StudioHero({ studio = false }) {
  return (
    <section className="studio-hero">
      <img src="/images/saunter-editorial-hero.png" alt="Collected interior with sage plaster, linen seating, antique oak, and softly falling daylight" className="hero-image" fetchpriority="high" />
      <div className="hero-shade" />
      <div className="studio-shell hero-content">
        <h1>{studio ? <>Spaces with<br />character.</> : <>A home,<br />considered.</>}</h1>
        <p className="hero-statement">Interior design, staging &amp; furniture curation.</p>
        <Link to={studio ? "/studio#contact" : "/studio"} className="hero-link">
          {studio ? "Tell us about your space" : "Explore our services"} <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  );
}
